/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransazioneVoucherSpendForm { 
    codice_voucher: string;
    id_negozio: string;
    valore_transazione: number;
    valore_scontrino?: number;
    numero_scontrino?: string;
    version: number;
    /**
     * Chiave di idempotenza (UUID) generata dal client per ogni operazione di addebito e rispedita identica nei retry. Se una transazione con la stessa chiave, stesso voucher, stesso negozio e stesso importo esiste già, non viene registrato un nuovo addebito e la risposta riporta l\'esito della transazione esistente (residuo, stato e version correnti). La stessa chiave con dati diversi è rifiutata (422). Facoltativa: se assente, nessuna protezione dai retry.
     */
    chiave_idempotenza?: string | null;
}

